import { TxSimulationMessage } from './tenderly'

const SecurityWarnings = () => (
  <>
    <TxSimulationMessage />
  </>
)

export default SecurityWarnings
